/**
 * Sanitize a string by escaping HTML entities
 * This provides defense-in-depth even though React escapes by default
 */
export function escapeHtml(text: string): string {
    const map: Record<string, string> = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
    };

    return text.replace(/[&<>"']/g, (char) => map[char] || char);
}

/**
 * Sanitize a string for use in CSS class names
 * Only allows alphanumeric characters, hyphens, and underscores
 */
export function sanitizeClassName(text: string): string {
    return text.replace(/[^a-zA-Z0-9_-]/g, '').toLowerCase();
}

/**
 * Sanitize user input by removing potentially dangerous characters
 */
export function sanitizeUserInput(input: string, maxLength: number = 10000): string {
    if(!input) return '';

    let sanitized = input.replace(/\0/g, '');

    sanitized = sanitized.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '');
    sanitized = sanitized.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    sanitized = sanitized.trim();

    if(sanitized.length > maxLength) {
        sanitized = sanitized.substring(0, maxLength);
    }

    return sanitized;
}
